<template>
	<div class="settings">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
			<v-card>
				<v-tabs v-model="tabOpen" centered grow>
					<v-tab href="#general">
						<v-icon left>settings</v-icon>
						<translate>General</translate>
					</v-tab>
					<v-tab href="#establishments" v-if="!$store.getters.isExternalEntity && $store.getters.hasRole('manager')">
						<v-icon left>mdi-home-city-outline</v-icon>
						<translate>Establishments</translate>
					</v-tab>
					<v-tab href="#users" v-if="$store.getters.hasRole('manager')">
						<v-icon left>people</v-icon>
						<translate>Users</translate>
					</v-tab>
					<!-- <v-tab href="#tests" v-if="$store.getters.hasRole('terapeut')">
						<v-icon left>assessment</v-icon>
						<translate>Tests</translate>
					</v-tab> -->
					<!-- <v-tab href="#treatments" v-if="$store.getters.hasRole('terapeut')">
						<v-icon left>mdi-clipboard-text</v-icon>
						<translate>Treatments</translate>
					</v-tab> -->
				</v-tabs>
			</v-card>
		</div>
		<template v-if="loading">
			<v-row no-gutters justify="center" align="center" style="height: 600px;">
				<v-progress-circular
					:size="50"
					color="primary"
					indeterminate
				></v-progress-circular>
			</v-row>
		</template>
		<v-tabs-items v-else v-model="tabOpen" class="mt-4">
			<v-tab-item value="general">
				<General :info="general" @edit-user-info="editUserInfo" @remove-speciality="removeSpeciality" />
			</v-tab-item>
			<v-tab-item value="establishments" v-if="!$store.getters.isExternalEntity && $store.getters.hasRole('manager')">
				<Establishments />
			</v-tab-item>
			<v-tab-item value="users" v-if="$store.getters.hasRole('manager')">
				<Users
					:users="users"
					:space="general.user_info.space"
					:specialities="general.specialities"
					@add-user="addUser"
					@delete-user="deleteUser"
					@deactivate-user="deactivateUser"
          @activate-user="activateUser"
				/>
			</v-tab-item>
			<!-- <v-tab-item value="tests">
				<Tests :tests="customTests"/>
			</v-tab-item> -->
			<!-- <v-tab-item value="treatments">
				<Treatments :customTreatments="customTreatments"/>
			</v-tab-item> -->
		</v-tabs-items>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import General from "@/components/settings/General.vue";
import Users from "@/components/settings/Users.vue";
import Establishments from "@/components/settings/Establishments.vue";
import axios from "axios";

export default {
	name: "Settings",
	props: {
		tab: {
			default: "general"
		}
	},
	components: {
		Breadcrumbs,
		General,
		Establishments,
		Users
	},
	data: () => ({
		loading: true,
		tabOpen: "",
		general: {
			user_info: { space: {}, specialities: [] },
			prescription_info: {},
			specialities: [],
			deleted_patients: []
		},
		users: []
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Settings"),
					disabled: true,
					link: true
				},
				{
					name: true,
					text: this.getTabName(),
					disabled: true,
					link: true
				}
			];
		}
	},
	methods: {
		editUserInfo(form) {
			axios
				.post("/settings", form)
				.then(response => {
					if (response.status === 200) {
						this.$store.dispatch("UPDATE_USER", response.data.user_info);
						console.log(response.data);
						this.general = response.data;
					}
				})
				.catch(error => console.log(error));
		},
		removeSpeciality(speciality) {
			axios
				.post("/speciality/" + speciality.id + "/delete")
				.then(response => {
					if (response.status === 200) {
						if (response.data.result === "deleted") {
							this.general.specialities.splice(
								this.general.specialities.indexOf(speciality),
								1
							);
						}
					}
				})
				.catch(error => console.log(error));
		},
		addUser(user) {
			this.users.push(user);
		},
		deleteUser(user) {
			axios
				.post("/user/" + user.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						if (response.data.result === "deleted") {
							this.users.splice(this.users.indexOf(user), 1);
						}
					}
				})
				.catch(error => console.log(error));
		},
		changeUserStatus(user, deactivated) {
			//let form = new FormData();
			//form.append("deactivated", deactivated);
			axios
				.post("/user/" + user.id + "/status", {deactivated: deactivated})
				.then(response => {
					console.log(response.data);
					if (response.data.result === 'ok') {
						user.deactivated = deactivated;
					}
				})
				.catch(error => console.log(error));
		},
		activateUser(user) {
			this.changeUserStatus(user, false);
		},
		deactivateUser(user) {
			this.changeUserStatus(user, true);
		},
		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		getTabName() {
			if (this.tabOpen === "general") return this.$gettext("General");
			else if (this.tabOpen === "establishments") return this.$gettext("Establishments");
			else if (this.tabOpen === "users") return this.$gettext("Users");
			else if (this.tabOpen === "treatments") return this.$gettext("Treatments");
			else if (this.tabOpen === "tests") return this.$gettext("Tests");
			return "";
		}
	},
	mounted() {
		this.tabOpen = this.tab;
	},
	created() {
		axios
			.get("/settings")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.general = response.data;
					this.general.user_info.monitoring_email_body = this.$store.getters.userMonitoringEmailBody;
					this.users = response.data.users;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>